import angular from 'angular';

export default angular.module('portainer.environments', []).name;
